import React, { useContext, useEffect, useState } from 'react';
import { Event } from '../types/Event'; // Import the Event type
import { EventContext } from '../context/EventContext';
import { getLogoDownloadUrl } from '../services/logoService';

interface EventCardProps {
  event: Event;
  onSelectEvent: (event: Event) => void; // Function to select the event
}

const EventCard: React.FC<EventCardProps> = ({ event, onSelectEvent }) => {
    const { currentEvent, setCurrentEvent } = useContext(EventContext);  // Assuming the event data is in context
    const [logoUrl, setLogoUrl] = useState<string>('');  // Assuming the event data is in context

    useEffect(() => {
      const fetchLogoUrl = async () => {
        if (event.logo) {
          try {
            const result = await getLogoDownloadUrl(event.event_id, event.logo);
            setLogoUrl(result);
          } catch (error) {
            console.error('Error fetching logo download URL:', error);
          }
        }
      };
  
      fetchLogoUrl();
    }, [currentEvent]);

  // Explicitly type the cardStyle object with React.CSSProperties
  const cardStyle: React.CSSProperties = {
    padding: '15px',
    borderRadius: '8px',
    border: event.event_id === currentEvent?.event_id ? '2px solid #2CAF80' : '1px solid #ddd', // Highlight border if match
    backgroundColor: event.event_id === currentEvent?.event_id ? '#f9fffa' : '#fff', // Light background for current event
    boxShadow: event.event_id === currentEvent?.event_id ? '0 4px 8px rgba(0, 150, 0, 0.2)' : '0 2px 4px rgba(0, 0, 0, 0.1)',
    width: '250px',
    minWidth: '250px',
    textAlign: 'center', // This is a valid value for textAlign
    marginRight: '15px',
    cursor: 'pointer',
  };

  const checkmarkStyle = {
    bottom: '10px',
    right: '10px',
    color: '#4CAF50', // Same color as the border to keep it cohesive
    fontStyle: 'italic',
    display: 'flex',
    alignItems: 'center',
    gap: '5px', // Spacing between checkmark and text
  };

  const logoStyle = {
    maxHeight: '30px',
    maxWidth: '30px',
    height: '30px'
  }

  const imageStyle: React.CSSProperties = {
    width: '100%',
    height: '150px',
    objectFit: 'cover',
    borderRadius: '8px',
  };

  return (
    <div style={cardStyle} onClick={() => onSelectEvent(event)}>
      {/* {event.logo && <img src={event.logo} alt={event.event_name} style={imageStyle} />} */}
      <h2>{logoUrl && (<img src={logoUrl} style={logoStyle} />)}{event.event_name}</h2>
      <h4><i>{event.event_type_name}</i></h4>
      <h3>{event.host_name}</h3>
      <p>{new Date(event.start_date).toLocaleDateString()}</p>

          {/* Conditional Checkmark and Label */}
    {event.event_id === currentEvent?.event_id && (
      <div style={checkmarkStyle}>
        <span>&#10003;</span> {/* Checkmark symbol */}
        <span>Current</span>
      </div>
    )}
    </div>
  );
};

export default EventCard;
